import {
  ClipboardCheck,
  FileText,
  LayoutDashboard,
  Package,
  Receipt,
  Settings,
  Users,
  Wallet,
  Wrench,
} from "lucide-react";

const NAV = [
  { k: "painel", l: "Painel", i: LayoutDashboard, papeis: ["admin", "atendente"] },
  { k: "clientes", l: "Clientes", i: Users, papeis: ["admin", "atendente"] },
  { k: "orcamentos", l: "Orçamentos", i: Receipt, papeis: ["admin", "atendente"] },
  { k: "recepcao", l: "Recepção e checklist", i: ClipboardCheck, papeis: ["admin", "mecanico", "atendente"] },
  { k: "os", l: "Ordens de serviço", i: Wrench, papeis: ["admin", "mecanico", "atendente"] },
  { k: "estoque", l: "Estoque", i: Package, papeis: ["admin", "mecanico"] },
  { k: "financeiro", l: "Financeiro", i: Wallet, papeis: ["admin", "atendente"] },
  { k: "notas", l: "Notas fiscais", i: FileText, papeis: ["admin", "atendente"] },
  { k: "config", l: "Configurações", i: Settings, papeis: ["admin"] },
];

/* O shell do protótipo (`AppAntigo`) foi removido daqui.
 *
 * Ele era exportado e nunca importado: produção monta `App.tsx`. Mas
 * carregava uma emissão de nota fiscal SIMULADA — esperava 1,1 segundo,
 * inventava número, chave de acesso e protocolo da SEFAZ, marcava a nota
 * como autorizada e avisava que o XML e o PDF já estavam disponíveis para
 * o cliente. Nada disso saía do navegador.
 *
 * Não chegava a rodar, mas ficava ali parecendo código vivo — e código
 * morto que finge estar vivo custa caro: mandou a mim mesmo, lendo este
 * arquivo, dar alarme falso sobre um risco que não existia. A emissão de
 * verdade é `acoes.emitirNota`, que chama POST /fiscal/emitir.
 *
 * Junto foi o `EMPRESA`, constante com CNPJ, ISS e ICMS fictícios. O ICMS
 * de 18% nunca existiu como campo em lugar nenhum do sistema.
 */

export { NAV };
